import { GetExtranetShopProductsQueryDto } from '@pharmac-extranet/extranet-api'
import { useLanguage } from '@pharmac-extranet/shared'
import { useInfiniteQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useCustomerContext } from '../../../features/customer/CustomerProvider'
import { getPages } from '../../../features/infinite-query/util/getPages'
import { api } from '../../../services/HttpService'
import { useShop } from '../useShop'
import { mapShopProductSearchParamsToQueryParams } from './query-parameter-mapping'

export const useShopProductsQuery = (onlySubscribed?: boolean) => {
  const { i18n } = useLanguage()
  const { customer } = useCustomerContext()
  const [searchParams, setSearchParams] = useSearchParams()
  const { langQuery } = useShop()
  const [params, setParams] = useState<GetExtranetShopProductsQueryDto>(
    mapShopProductSearchParamsToQueryParams(searchParams)
  )

  // Added this to force new data from refetch to be show on the page
  const [state, setState] = useState(0)
  
  useEffect(() => {
    setState(state + 1)
  }, [
    onlySubscribed
  ])

  const fetchPage = (pageParam: number) => {
    return api.shop.getShopProducts(customer!.id, {
      ...params,
      pageSize: 10,
      onlySubscribed,
      language: langQuery(i18n.language),
      page: pageParam,
    })
  }

  const {
    data,
    isLoading: shopProductsIsLoading,
    fetchNextPage,
  } = useInfiniteQuery({
    queryKey: [
      '__shopProducts',
      customer?.id,
      params.productFamily,
      params.search,
      params.productGroupId,
      params.freeOrPaidProduct,
      params.publishDateRangeStart,
      params.publishDateRangeStart,
      params.tagIds,
      params.filterByLanguage,
      params.sortKey,
      params.sortOrder,
      onlySubscribed,
      state,
      langQuery(i18n.language),
    ],
    queryFn: ({ pageParam }) => fetchPage(pageParam),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => (lastPage.hasMore ? lastPage.page + 1 : undefined),
    
  })

  const shopProducts = getPages(data)  

  return {
    params,
    searchParams,
    shopProducts,
    shopProductsIsLoading,
    setParams,
    setSearchParams,
    fetchNextPage,
  }
}
